import { FileContent, FileContentFactory } from "../";
import { TaxIncomeCertificate } from "./taxIncomeCertificate.model";
import { ModifyTaxIncomeCertificate, ModifyTaxIncomeCertificateFactory } from "./modifyTaxIncomeCertificate.model";

export interface AdultFamilyMember {
    fullName: string;
    taxIncomeCertificate: TaxIncomeCertificate;
    ownsPropertyDocument: string;
}

export interface ModifyAdultFamilyMember {
    fullName: string;
    taxIncomeCertificate: ModifyTaxIncomeCertificate;
    ownsPropertyDocument: FileContent;
}

export class ModifyAdultFamilyMemberFactory {
    static create(): ModifyAdultFamilyMember {
        return {
            fullName: "",
            taxIncomeCertificate: ModifyTaxIncomeCertificateFactory.create(),
            ownsPropertyDocument: FileContentFactory.create(),
        };
    }

    static from(member: AdultFamilyMember | undefined | null): ModifyAdultFamilyMember {
        if (!member) {
            return ModifyAdultFamilyMemberFactory.create();
        }
        return {
            fullName: member.fullName ?? "",
            taxIncomeCertificate: ModifyTaxIncomeCertificateFactory.from(member.taxIncomeCertificate),
            ownsPropertyDocument: FileContentFactory.fromUrl(member.ownsPropertyDocument ?? ""),
        };
    }
}

export function resizeAdultFamilyMembers(
    current: ModifyAdultFamilyMember[],
    newCount: number,
): ModifyAdultFamilyMember[] {
    const resized = [...current];
    while (resized.length < newCount) {
        resized.push(ModifyAdultFamilyMemberFactory.create());
    }
    if (resized.length > newCount) {
        resized.length = newCount;
    }
    return resized;
}
